import PriceRowAgentHubCommission from 'agentHub/components/PriceRowAgentHubCommission'
import FormatCurrency from 'components/Common/FormatCurrency'
import CruisesDiscountTsAndCsModal from 'components/Cruises/CruisesDiscountTsAndCsModal'
import PriceRowCaption from 'LuxKit/PricePoints/PriceRowCaption'
import PriceRowPrice from 'LuxKit/PricePoints/PriceRowPrice'
import PriceRowPriceCaption from 'LuxKit/PricePoints/PriceRowPriceCaption'
import PriceRowTaxesAndFees from 'LuxKit/PricePoints/PriceRowTaxesAndFees'
import PriceRowValueDiscountWithCaption from 'LuxKit/PricePoints/Value/PriceRowValueDiscountWithCaption'
import ModalContext from 'contexts/ModalContext'
import type { CruiseOfferView } from 'hooks/Cruise/useCruiseOfferView'
import useCruiseSelectedCabinType from 'hooks/useCruiseSelectedCabinType'
import React, { useCallback, useContext } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

interface Props {
  view: CruiseOfferView
}

function CruiseSearchTilePricing({ view }: Props) {
  const intl = useIntl()
  const {
    lowestPrice,
    discountPills,
  } = view

  const selectedCabinType = useCruiseSelectedCabinType(view.cruiseType)

  const showModal = useContext(ModalContext)

  const openDiscountTermsAndConditionsModal = useCallback(() => {
    showModal(<CruisesDiscountTsAndCsModal />)
  }, [showModal])

  const twinShareLabel = intl.formatMessage({
    id: 'vyFtiQ650X',
    defaultMessage: 'Twin Share',
    description: 'Cruise cabin pricing basis label',
  })

  const priceCaption = selectedCabinType
    ? intl.formatMessage(
        {
          id: 'HivnsiceXi',
          defaultMessage: '{cabinType} from',
          description: 'Cruise search tile price caption with cabin type',
        },
        { cabinType: selectedCabinType },
      )
    : intl.formatMessage({
        id: 'SyeN89mAiH',
        defaultMessage: 'From',
        description: 'Cruise search tile price caption without cabin type',
      })

  return <div>
    <PriceRowPriceCaption>{priceCaption}</PriceRowPriceCaption>
    {lowestPrice && <PriceRowPrice
      size="L"
      price={lowestPrice.primaryPrice.total}
      saleUnit={lowestPrice.primaryPrice.type}
    />}
    {lowestPrice?.secondaryPrice && <PriceRowCaption>
      <FormattedMessage
        id="tS3bNBvwd/"
        defaultMessage="{price} /{priceType} · {twinShare}"
        description="Cruise search tile secondary price with type and twin share label"
        values={{
          price: <FormatCurrency value={lowestPrice.secondaryPrice.total} />,
          priceType: lowestPrice.secondaryPrice.type,
          twinShare: twinShareLabel,
        }}
      />
    </PriceRowCaption>}
    {!lowestPrice?.secondaryPrice && discountPills?.price && discountPills.discountPercentage && <PriceRowValueDiscountWithCaption
      size="M"
      originalValue={discountPills.price}
      discountPercentage={discountPills.discountPercentage}
      onInfoIconClick={openDiscountTermsAndConditionsModal}
    />}
    {!lowestPrice?.secondaryPrice && <PriceRowCaption>{twinShareLabel}</PriceRowCaption>}
    <PriceRowTaxesAndFees />
    <PriceRowAgentHubCommission
      offerId={view.offer.id}
      offer={view.offer}
      productType={view.offer.productType}
    />
  </div>
}

export default CruiseSearchTilePricing
